import { render, staticRenderFns } from "./gurudwara-admin.vue?vue&type=template&id=2eebc598"
import script from "./gurudwara-admin.vue?vue&type=script&lang=js"
export * from "./gurudwara-admin.vue?vue&type=script&lang=js"
import style0 from "./gurudwara-admin.vue?vue&type=style&index=0&id=2eebc598&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports